module.exports = __webpack_public_path__ + "img/zcimg.2fe2a6cd.png";